import { useRef } from 'react';
import { QrCode, Smartphone } from 'lucide-react';
import QrFrame from './QrFrame';
import QrStyledRenderer from './QrStyledRenderer';

export default function QrPreview({ value, style, variant = 'sidebar' }) {
  const displaySize = Math.min(style.size, variant === 'sidebar' ? 240 : 280);
  const instanceRef = useRef(null);

  return (
    <div className="flex w-full flex-col items-center">
      <div className="mb-4 w-full text-center">
        {value ? (
          <>
            <p className="text-sm font-semibold text-slate-900">Live preview</p>
            <p className="mt-1 flex items-center justify-center gap-1.5 text-xs text-slate-500">
              <Smartphone className="h-3.5 w-3.5 shrink-0" aria-hidden />
              Scan to test on your phone
            </p>
          </>
        ) : (
          <>
            <p className="text-sm font-semibold text-slate-500">Preview</p>
            <p className="mt-1 text-xs text-slate-400">Updates as you type</p>
          </>
        )}
      </div>

      {!value ? (
        <div
          className="flex aspect-square w-full max-w-[260px] flex-col items-center justify-center rounded-xl border-2 border-dashed border-slate-200 bg-white p-6 text-center"
          aria-hidden
        >
          <QrCode className="mb-2 h-10 w-10 text-slate-300" strokeWidth={1.5} />
          <p className="text-xs text-slate-400">Enter content to generate</p>
        </div>
      ) : (
        <div className="w-full max-w-[280px] rounded-xl bg-white p-4 ring-1 ring-slate-200/80">
          <div className="mb-3 flex justify-center" aria-live="polite">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" aria-hidden />
              Ready to scan
            </span>
          </div>
          <div className="flex justify-center" aria-label="Generated QR code preview">
            <QrFrame
              type={style.frameType}
              phrase={style.framePhrase}
              frameColor={style.frameColor}
              textColor={style.frameTextColor}
              font={style.frameFont}
            >
              <QrStyledRenderer
                value={value}
                style={style}
                renderSize={displaySize}
                instanceRef={instanceRef}
              />
            </QrFrame>
          </div>
        </div>
      )}
    </div>
  );
}
